import { Avatar, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, ButtonGroup, Checkbox, Divider, Flex, FormControl, FormLabel, Input, Select, Stack, Text, list, useColorModeValue, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Step,
    StepDescription,
    StepIcon,
    StepIndicator,
    StepNumber,
    StepSeparator,
    StepStatus,
    StepTitle,
    Stepper,
    useSteps,
} from "@chakra-ui/react";
import ReactSelect from 'react-select';
import axiosClient from '../../../axios-client';
import { useStateContext } from '../../../context/ContextProvider';
import countriesData from '../../../assets/dataJson/countries.json';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import { AsyncPaginate } from 'react-select-async-paginate'; function NewOrder() {

    const { user, setToken, setUser, dataSubscriptionUser, getAbonnementClient, currentBusiness } = useStateContext()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { activeStep, setActiveStep } = useSteps({ index: 0 });
    const steps = [
        { title: t("Informations client") },
        { title: t("Produits") },
        { title: "Coupon" },
    ];

    const [dataProduct, setDataProduct] = useState([
        {
            produit: '',
        },
    ])

    const [dataProduit, setDataProduit] = useState([])
    const [optionsTitre, setOptionsTitre] = useState([])

    const toast = useToast()

    const fetchData = async (userId, userRole) => {
        await axiosClient.get(`/products/get_All_Products/?client=${userId}&userRole=${userRole}&business=${currentBusiness.id}`).then(res => {
            setDataProduit(res.data)

            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
        })
    }

    useEffect(() => {
        if (user.id) {
            fetchData(user.id, user?.role)
        }
    }, [user.id])

    //Var Info Client
    const [nomCompletClient, setNomCompletClient] = useState()
    const [emailClient, setEmailClient] = useState()
    const [paysClient, setPaysClient] = useState('')
    const [codeCountryClient, setCodeCountryClient] = useState('')
    const [villeClient, setVilleClient] = useState('')

    const countryOptions = countriesData.countries;
    const [adresseClient, setAdresseClient] = useState()
    const [phoneClient, setPhoneClient] = useState('')
    const [phoneCode, setPhoneCode] = useState('+212')
    const [totalPrice, setTotalPrice] = useState(0)

    //Var Coupon
    const [codeCoupon, setCodeCoupon] = useState(null)
    const [dataCoupon, setDataCoupon] = useState([])

    const fetchDataCoupon = async () => {
        await axiosClient.get(`/coupons/get_All_Coupons_For_New_Order/?client=${user?.id}&business=${currentBusiness?.id}`).then(res => {
            setDataCoupon(res.data)
            // console.log('DATA COUPON : ', res.data);
            if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");
                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
            }
        })
    }

    useEffect(() => {
        if (user.id) {
            fetchDataCoupon()
        }
    }, [user.id])





    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    const getColor = (id) => {
        let colorOptions = dataProduit.find(e => e.id === id)?.stock
            .filter(e => e.color.length !== 0)
            .map(val => ({ value: val.id, label: val.color.toLowerCase() }));

        // Supprimer les doublons en ignorant la casse
        colorOptions = Array.from(
            new Map(colorOptions.map(item => [item.label.toLowerCase(), item])).values()
        );

        return colorOptions;
    };


    const getSize = (id) => {
        let sizeOptions = dataProduit.find(e => e.id === id)?.stock
            .filter(e => e.size.length !== 0)
            .map(val => ({ value: val.id, label: val.size.toLowerCase() }));

        // Supprimer les doublons en ignorant la casse
        sizeOptions = Array.from(
            new Map(sizeOptions.map(item => [item.label.toLowerCase(), item])).values()
        );

        return sizeOptions;
    };



    const handleChangeTitleProduct = (e, index) => {
        const { value, label } = e
        // console.log(index, ' Selected : value : ', label);

        setDataProduct(prevState => {
            const newData = [...prevState];
            // let dataCouleur = []

            // for (let index = 0; index < dataProduit.find(e => e.id === value)?.properties.length; index++) {
            //     dataCouleur.push({
            //         value: index,
            //         label: dataProduit.find(e => e.titre === label)?.properties[index].couleur
            //     })
            // }

            // let dataTaille = []

            // for (let index = 0; index < dataProduit.find(e => e.titre === label)?.properties.length; index++) {
            //     dataTaille.push({
            //         value: index,
            //         label: dataProduit.find(e => e.titre === label)?.properties[index].taille
            //     })
            // }
            // console.log('DATAAA : ', {
            //     image: dataProduit.find(e => e.titre === label)?.image,
            //     produit: e,
            //     couleur: '',
            //     taille: '',
            //     quantite: null,
            //     prix: null
            // });

            newData[index] = {
                ...newData[index],
                image: dataProduit.find(e => e.id === value)?.images[0]?.image,
                produit: e,
                couleur: '',
                taille: '',
                quantite: null,
                prix: null
            };
            return newData;
        });
    }

    const addNewDataProduct = () => {
        // console.log('DATAAA : 2 ', dataProduct);
        setDataProduct([...dataProduct, { produit: '' }])
    }

    const removeDataProduct = (index) => {
        const listDataProduct = [...dataProduct]
        listDataProduct.splice(index, 1)
        setDataProduct(listDataProduct)
    }

    const handleChangeInputs = (e, index) => {
        const { name, value } = e.target
        const listProduct = [...dataProduct]

        if (name === "prix") {
            const formattedValue = handlePriceChange(value);
            if (formattedValue !== null) {
                listProduct[index][name] = formattedValue;
                setDataProduct(listProduct);
            }
        } else {
            listProduct[index][name] = value
            setDataProduct(listProduct)
        }
    }


    const handleChangeInputsColorAndSize = (e, name, index) => {
        const { value, label } = e
        // console.log(index, " Value : ", value, ' label : ', label, ' name: ', name);
        const listProduct = [...dataProduct]
        listProduct[index][name] = e
        // console.log(listProduct);
        setDataProduct(listProduct)
    }

    const addTotalPrice = () => {
        let total = 0
        dataProduct.forEach((item) => {
            // Convertir la quantité et le prix en nombre et l'ajouter au total
            total += formatPriceForBackend(item.prix || 0) * (parseInt(item.quantite) || 0);
        });
        setTotalPrice(total.toFixed(2));
    }


    const removeTotlaPrice = (prix, quantite) => {
        if (prix && quantite) {
            setTotalPrice((parseFloat(totalPrice) - (formatPriceForBackend(prix) * parseInt(quantite))).toFixed(2));
        }
    };


    const [checkBoxCoupon, setCheckBoxCoupon] = useState(false)

    const bgCard = useColorModeValue("gray", "gray.400")


    const addOrdre = async () => {
        try {
            const formData = new FormData()
            formData.append('full_name', nomCompletClient)
            formData.append('email', emailClient)
            formData.append('pays', paysClient)
            formData.append('code_country', codeCountryClient)
            formData.append('ville', villeClient)
            formData.append('address', adresseClient)
            formData.append('tel', `${phoneCode} ${phoneClient}`)
            // formData.append('status_confirmation', 'Nouveau')
            // formData.append('price', totalPrice)
            formData.append('order_added_by', user.id)
            formData.append('coupon_code', codeCoupon)
            // formData.append('price', totalPrice)
            formData.append('client_id', user.id)
            formData.append('business', currentBusiness.id)
            formData.append('products', JSON.stringify(dataProduct))

            if (parseInt(dataSubscriptionUser?.subscription?.orders_count) === parseInt(dataSubscriptionUser?.orders_limit)) {
                toast({
                    description: t("Vous avez atteint la limite de commandes de votre abonnement"),
                    status: 'warning',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
                return
            }

            await axiosClient.post(`/commandes/create_order/`, formData).then(async (res) => {
                // console.log('res.data : ', res.data);
                getAbonnementClient()
                // console.log('ID PRODUIT : ', dataProduct[0].produit.value, ' ID COMMANDE : ', res.data.id, ' QUANTITY : ', dataProduct[0].quantite);
                // for (let index = 0; index < dataProduct.length; index++) {

                //     await axiosClient.post('/produitCommande/', {
                //         product: dataProduct[index].produit.value,
                //         commande: res.data.id,
                //         color: dataProduct[index].couleur.label,
                //         size: dataProduct[index].taille.label,
                //         quantity: parseInt(dataProduct[index].quantite),
                //         price: parseFloat(dataProduct[index].prix),
                //     })
                // }
                // await axiosClient.patch(`client-subscriptions/${dataSubscriptionUser?.subscription?.id}/`, {
                //     orders_count: parseInt(dataSubscriptionUser?.subscription?.orders_count) + 1
                // })
                navigate('/list_new_orders')
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    const colorbg = useColorModeValue('white', '#2d3748')

    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')

    return (
        <Box>
            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Breadcrumb fontFamily='Plus Jakarta Display' fontStyle={"italic"} fontSize={{ base: "20px", sm: "25px", lg: "27px" }} color="gray">
                        <BreadcrumbItem>
                            <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                        </BreadcrumbItem>


                        <BreadcrumbItem >
                            <BreadcrumbLink onClick={() => navigate('/list_new_orders')}>{t("Nouvelles commandes")} </BreadcrumbLink>
                        </BreadcrumbItem>
                        <BreadcrumbItem isCurrentPage>
                            <BreadcrumbLink>{t("Ajouter commande")} </BreadcrumbLink>
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Box>
            </Flex>

            <Flex justify="center">
                <Stepper w={{ base: "100%", lg: "75%" }} index={activeStep}>
                    {steps.map((step, index) => (
                        <Step key={index}>
                            <StepIndicator>
                                <StepStatus
                                    complete={<StepIcon />}
                                    incomplete={<StepNumber />}
                                    active={<StepNumber />}
                                />
                            </StepIndicator>

                            <Box flexShrink="0">
                                <StepTitle>{step.title}</StepTitle>
                                <StepDescription>{step.description}</StepDescription>
                            </Box>

                            <StepSeparator />
                        </Step>
                    ))}
                </Stepper>
            </Flex>

            <Stack
                bg={useColorModeValue("white", "#212835")}
                borderWidth="1px"
                rounded="xl"
                w={{ base: "100%", lg: "75%" }}
                shadow="1px 1px 3px rgba(0,0,0,0.3)"
                p={6}
                m="10px auto"
                as="form"
            >
                {activeStep === 0 ?

                    <>
                        <Flex>
                            <Text color={bgCard}>{t("Informations client")}</Text>
                        </Flex>
                        <Flex gap={4}>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("Nom complet")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Nom complet')} value={nomCompletClient} onChange={e => setNomCompletClient(e.target.value)} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    Email {t("(optionnel)")}
                                </FormLabel>
                                <Input type='email' placeholder='Email' value={emailClient} onChange={e => setEmailClient(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4}>
                            <FormControl>
                                <FormLabel>
                                    {t("Pays")}  {t("(optionnel)")}
                                </FormLabel>
                                <ReactSelect
                                    options={countryOptions}
                                    placeholder={t('Sélectionnez un pays')}
                                    onChange={(selected) => {
                                        setPaysClient(selected ? selected.label : '');
                                        setCodeCountryClient(selected ? selected.value : '');
                                    }}
                                    value={countryOptions.find(opt => opt.value === codeCountryClient) || null}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'gray.200'
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            textAlign: 'left',
                                            backgroundColor: colorbg,
                                            cursor: "pointer"
                                        }),
                                        option: (provided, state) => ({
                                            backgroundColor: colorbg,
                                            ...provided,
                                            color: txtcolor,
                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                            '&:hover': {
                                                backgroundColor: colorbghover,
                                            },
                                            cursor: "pointer"
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        }),
                                    }}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>
                                    {t("Ville")} {t("(optionnel)")}
                                </FormLabel>
                                <Input type='email' placeholder={t('Ville')} value={villeClient} onChange={e => setVilleClient(e.target.value)} />
                            </FormControl>
                        </Flex>
                        <Flex gap={4}>
                            <FormControl>
                                <FormLabel>
                                    {t("Adresse")} {t("(optionnel)")}
                                </FormLabel>
                                <Input type='text' placeholder={t('Adresse')} value={adresseClient} onChange={e => setAdresseClient(e.target.value)} />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>
                                    {t("N°téléphone")}
                                </FormLabel>
                                <Flex
                                    alignItems="center"
                                    borderWidth="1px"
                                    borderColor="var(--chakra-colors-gray-200)"
                                    borderRadius="md"
                                    _focusWithin={{
                                        borderColor: "blue.500",
                                        boxShadow: "0 0 0 1px #3182ce"
                                    }}
                                    bg="transparent"
                                    transition="all 0.2s"
                                >
                                    <Box width="140px" borderRight="1px solid" borderColor="var(--chakra-colors-gray-200)">
                                        <ReactSelect
                                            options={countryOptions.map((c) => ({
                                                value: c.phoneCode,
                                                label: `${c.label.split(' ')[0]} ${c.phoneCode}`,
                                                fullLabel: `${c.label} (${c.phoneCode})`
                                            }))}
                                            value={{ value: phoneCode, label: phoneCode }}
                                            onChange={(selected) => setPhoneCode(selected.value)}
                                            formatOptionLabel={(data, { context }) => (
                                                context === 'menu' ? data.fullLabel : data.label
                                            )}
                                            styles={{
                                                control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    backgroundColor: 'transparent',
                                                    borderColor: 'transparent',
                                                    boxShadow: 'none',
                                                    cursor: "pointer",
                                                    "&:hover": { borderColor: "transparent" }
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    backgroundColor: colorbg,
                                                    zIndex: 9999,
                                                    width: '280px'
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                    color: txtcolor,
                                                    '&:hover': {
                                                        backgroundColor: colorbghover,
                                                    },
                                                    cursor: "pointer"
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: txtcolor,
                                                    fontWeight: "600" // Make phone code stand out slightly
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: "4px"
                                                })
                                            }}
                                        />
                                    </Box>
                                    <Input
                                        type='tel'
                                        pattern="^[0-9]*$"
                                        variant="unstyled"
                                        pl={3}
                                        py={2}
                                        height="100%"
                                        placeholder={t("N°téléphone")}
                                        value={phoneClient}
                                        onChange={e => {
                                            const val = e.target.value;
                                            if (val === '' || /^[0-9]*$/.test(val)) {
                                                setPhoneClient(val);
                                            }
                                        }}
                                    />
                                </Flex>
                            </FormControl>
                        </Flex>
                    </>
                    : activeStep === 1
                        ?

                        <>
                            <Flex>
                                <Text color={bgCard}>{t("Informations du produit")}</Text>
                            </Flex>
                            {dataProduct.map((val, key) => {
                                return (
                                    <>
                                        <Flex key={key} alignItems={'center'} gap={5} w={'100%'} flexDirection={"column"}>

                                            <FormControl isRequired w={'50%'}>
                                                <FormLabel>
                                                    {t("Liste des produits")}
                                                </FormLabel>
                                                <AsyncPaginate
                                                    loadOptions={loadProductOptions}
                                                    additional={{ page: 1 }}
                                                    onChange={e => handleChangeTitleProduct(e, key)}
                                                    name='produit'
                                                    value={val.produit}
                                                    placeholder={t("Produits")}
                                                    noOptionsMessage={() => t("Aucun produit trouvé")}

                                                    styles={{

                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            backgroundColor: 'transparent',
                                                            borderColor: 'gray.200'

                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            textAlign: 'left',
                                                            backgroundColor: colorbg,
                                                            cursor: "pointer",
                                                            zIndex: 9999
                                                        }),
                                                        option: (provided, state) => ({
                                                            backgroundColor: colorbg,

                                                            ...provided,
                                                            color: txtcolor,
                                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                            '&:hover': {
                                                                backgroundColor: colorbghover,
                                                            },

                                                            cursor: "pointer"
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: txtcolor,
                                                        }),

                                                    }}
                                                />
                                            </FormControl>

                                            {val.image && <Avatar
                                                h={150}
                                                w={150}
                                                borderRadius='12px'
                                                me='18px'
                                                name='Dan Abrahmov' src={val.image} />}
                                        </Flex>
                                        <Flex gap={4}>
                                            {(val.produit && getColor(val.produit.value).length !== 0) && <FormControl isRequired>
                                                <FormLabel>
                                                    {t("Couleur")}
                                                </FormLabel>
                                                <ReactSelect
                                                    onChange={e => handleChangeInputsColorAndSize(e, 'couleur', key)}
                                                    value={val.couleur}
                                                    options={getColor(val.produit.value)}
                                                    placeholder={t("Couleur")}

                                                    styles={{

                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            backgroundColor: 'transparent',
                                                            borderColor: 'gray.200'

                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            textAlign: 'left',
                                                            backgroundColor: colorbg,
                                                            cursor: "pointer"
                                                        }),
                                                        option: (provided, state) => ({
                                                            backgroundColor: colorbg,

                                                            ...provided,
                                                            color: txtcolor,
                                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                            '&:hover': {
                                                                backgroundColor: colorbghover,
                                                            },

                                                            cursor: "pointer"
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: txtcolor,
                                                        }),

                                                    }}
                                                />
                                                {/* <Input type='text' placeholder='Couleur' name='couleur' value={val.couleur} onChange={e => handleChangeInputs(e, key)} /> */}
                                            </FormControl>}
                                            {(val.produit && getSize(val.produit.value).length !== 0) && <FormControl isRequired>
                                                <FormLabel>
                                                    {t("Taille")}
                                                </FormLabel>
                                                <ReactSelect
                                                    onChange={e => handleChangeInputsColorAndSize(e, 'taille', key)}
                                                    value={val.taille}
                                                    options={getSize(val.produit.value)}
                                                    placeholder={t("Taille")}

                                                    styles={{

                                                        control: (baseStyles, state) => ({
                                                            ...baseStyles,
                                                            backgroundColor: 'transparent',
                                                            borderColor: 'gray.200'

                                                        }),
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            textAlign: 'left',
                                                            backgroundColor: colorbg,
                                                            cursor: "pointer"
                                                        }),
                                                        option: (provided, state) => ({
                                                            backgroundColor: colorbg,

                                                            ...provided,
                                                            color: txtcolor,
                                                            backgroundColor: state.isSelected ? colorbg : 'inherit',
                                                            '&:hover': {
                                                                backgroundColor: colorbghover,
                                                            },

                                                            cursor: "pointer"
                                                        }),
                                                        singleValue: (provided) => ({
                                                            ...provided,
                                                            color: txtcolor,
                                                        }),

                                                    }}
                                                />
                                                {/* <Input type='text' placeholder='Taille' name='taille' value={val.taille} onChange={e => handleChangeInputs(e, key)} /> */}
                                            </FormControl>}
                                        </Flex>
                                        <Flex gap={4}>
                                            {val.produit && <FormControl isRequired>
                                                <FormLabel>
                                                    {t("Quantité")}
                                                </FormLabel>
                                                <Input type='text' placeholder={t('Quantité')} name='quantite' value={val.quantite} onChange={e => {
                                                    handleChangeInputs(e, key)
                                                    addTotalPrice()
                                                }} />
                                            </FormControl>}
                                            {val.produit && <FormControl isRequired>
                                                <FormLabel display={"flex"} alignItems={"center"} gap={1}>
                                                    <Text>{t("Prix de ventes")}</Text>
                                                    <Text fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                </FormLabel>
                                                <Input type='text' placeholder={t('Prix')} name='prix' value={val.prix} onChange={e => {
                                                    handleChangeInputs(e, key)
                                                    addTotalPrice()
                                                }} />
                                            </FormControl>}
                                        </Flex>


                                        <Flex justifyContent={"end"} mt={3} gap={3}>
                                            <Flex justifyContent={"end"} gap={3}>
                                                {dataProduct.length > 1 && (
                                                    <Button
                                                        colorScheme="red"
                                                        size={"sm"}
                                                        variant={"outline"}
                                                        onClick={() => {
                                                            removeDataProduct(key);
                                                            removeTotlaPrice(val.prix, val.quantite)
                                                            // removeTotlaQntt(val.quantity);
                                                            // removeTotlaPrice(val.price);
                                                        }}
                                                    >
                                                        {t("Supprimer")}
                                                    </Button>
                                                )}
                                                {dataProduct.length - 1 === key && (
                                                    <Button
                                                        colorScheme="green"
                                                        size={"sm"}
                                                        variant={"outline"}
                                                        onClick={() => {
                                                            addNewDataProduct();
                                                        }}
                                                    >
                                                        Plus
                                                    </Button>
                                                )}
                                            </Flex>
                                        </Flex>
                                        <Divider orientation='horizontal' />
                                    </>
                                )
                            })}
                        </>
                        :

                        <>
                            <Flex>
                                <Text color={bgCard}>Coupon</Text>
                            </Flex>
                            <Flex w={"100%"} justify={"center"}>
                                <Checkbox size='lg' colorScheme='purple' _focus={"none"} isChecked={checkBoxCoupon} onChange={(e) => setCheckBoxCoupon(e.target.checked)}>
                                    {t("Cette commande contient un coupon ?")}
                                </Checkbox>
                            </Flex>
                            <Flex justify={"center"}>
                                {checkBoxCoupon && <FormControl w={'50%'} mt={3} isRequired>
                                    <FormLabel>
                                        {t("Code coupon")}
                                    </FormLabel>
                                    <Select value={codeCoupon} onChange={e => setCodeCoupon(e.target.value)}>
                                        <option value="">{t("Sélectionner un coupon")}</option>
                                        {dataCoupon.map((val, key) => {
                                            return (
                                                <option key={key} value={val.code}>{val.code}</option>
                                            )
                                        })}
                                    </Select>
                                    {/* <Input type='text' placeholder={t("Code coupon")} value={codeCoupon} onChange={e => setCodeCoupon(e.target.value)} /> */}
                                </FormControl>}
                            </Flex>
                        </>
                }

                <ButtonGroup mt="5%" w="100%">
                    <Flex w="100%" justifyContent="space-between">
                        <Flex>
                            <Button
                                onClick={() => {
                                    setActiveStep(activeStep - 1)
                                    // setProgress(progress - 33.33);
                                }}
                                isDisabled={activeStep === 0}
                                colorScheme="blue"
                                variant="solid"
                                w="7rem"
                                mr="5%"
                            >
                                {t("Précédent")}
                            </Button>
                            <Button
                                w="7rem"
                                isDisabled={activeStep === 2}
                                onClick={() => {
                                    if (activeStep === 0) {
                                        if (!nomCompletClient || !phoneClient) {
                                            toast({
                                                description: t("Veuillez remplir tous les champs obligatoires"),
                                                status: 'warning',
                                                variant: 'left-accent',
                                                duration: 2000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                            return
                                        } else {
                                            setActiveStep(activeStep + 1)
                                        }

                                    }
                                    else if (activeStep === 1) {
                                        const isNumeric = (value) => {
                                            return /^\d*\.?\d+$/.test(value); // Accepte les nombres entiers et décimaux
                                        };
                                        const hasEmptyProductFields = dataProduct.some(item => {
                                            return !item.produit ||
                                                (getColor(item.produit.value).length > 0 && !item.couleur) ||
                                                (getSize(item.produit.value).length > 0 && !item.taille) ||
                                                !item.quantite ||
                                                !item.prix;
                                        });

                                        if (hasEmptyProductFields) {
                                            toast({
                                                description: t("Veuillez remplir tous les champs obligatoires pour les produits"),
                                                status: 'error',
                                                variant: 'left-accent',
                                                duration: 2000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                            setActiveStep(1);
                                            return;
                                        }

                                        // Validation des nombres
                                        const hasInvalidNumbers = dataProduct.some(item => {
                                            return !isNumeric(item.quantite) || !isNumeric(item.prix);
                                        });

                                        if (hasInvalidNumbers) {
                                            toast({
                                                description: t("Les champs quantité et prix doivent contenir uniquement des chiffres"),
                                                status: 'error',
                                                variant: 'left-accent',
                                                duration: 2000,
                                                isClosable: true,
                                                position: 'bottom-right'
                                            });
                                            setActiveStep(1);
                                            return;
                                        }


                                        setActiveStep(activeStep + 1)

                                    }
                                    // else {
                                    //     setActiveStep(activeStep + 1)
                                    // }
                                }}
                                colorScheme="blue"
                                variant="outline"
                            >
                                {t("Suivant")}
                            </Button>
                        </Flex>

                    </Flex>
                </ButtonGroup>
            </Stack>

            <Flex
                justify={'center'}>
                <Flex w={{ base: '100%', lg: '75%' }} justify={"end"}>
                    {activeStep === 2 ? (
                        <Button
                            w="7rem"
                            colorScheme="purple"
                            size={"md"}
                            variant={"outline"}
                            onClick={addOrdre}
                        >
                            {t("Ajouter")}
                        </Button>
                    ) : null}
                </Flex>
            </Flex>
        </Box>
    )
}

export default NewOrder